module.exports = __webpack_public_path__ + "static/media/aspect.bc552787.jpg";